import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Subscription, forkJoin, ReplaySubject } from "rxjs";

import { TextAlignment } from "@shared/Enums/text-alignment.enum";

import mensajes from "../../../assets/constantes/mensajes.json";
import { ModalTitles, ModalType } from "../../../shared/Constantes/modal.constantes";
import { Perfil } from "../../../shared/Entities/Perfil/perfil.entity";
import { Usuario } from "../../../shared/Entities/Usuario/usuario.entity";
import { PerfilRepository } from "../../../shared/Repositories/perfil.repository";
import { RolesRepository } from "../../../shared/Repositories/roles.repository";
import { UsuariosRepository } from "../../../shared/Repositories/usuarios.repository";
import { ModalService } from "../../../shared/Services/modal.service";
import { FormularioPerfilesComponent } from "../Formulario/formulario.component";

@Component({
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardPerfilesComponent implements OnInit, OnDestroy {
  public subscriptions: Subscription[] = [];
  public currentUser: Usuario;
  public perfiles: Perfil[] = [];
  public observablePerfiles: ReplaySubject<Perfil[]> = new ReplaySubject(1);
  public selectedPerfiles: Perfil[] = [];
  public bsModalRef: BsModalRef;
  public excelName = "Perfiles";
  public columns = [];
  public searchCols: string[] = ["nombre", "descripcion"];
  @ViewChild("actions", { static: true }) public actionsTemplate;

  constructor(
    private usuarioRepository: UsuariosRepository,
    private perfilRepository: PerfilRepository,
    private rolesRepository: RolesRepository,
    private bsModalService: BsModalService,
    private modalService: ModalService
  ) {}

  public ngOnInit(): void {
    this.subscriptions.push(
      this.usuarioRepository.getInfoClienteActual().subscribe((currentUser) => {
        this.currentUser = currentUser;
      })
    );
    this.getPerfiles(true);
    this.getRoles(true);

    this.columns = [
      {
        name: "Acciones",
        prop: "",
        width: 160,
        headerClass: TextAlignment.Center,
        cellTemplate: this.actionsTemplate,
        selected: true,
        dontPrint: true,
      },
      {
        name: "Nombre",
        prop: "nombre",
        selected: true,
      },
      {
        name: "Descripción",
        prop: "descripcion",
        selected: true,
      },
      {
        name: "Roles",
        prop: "roles",
        selected: true,
      },
    ];
  }

  public addPerfil(): void {
    this.bsModalRef = this.bsModalService.show(FormularioPerfilesComponent);
    this.bsModalRef.content.onClose.subscribe((perfilModificado) => {
      if (perfilModificado === true) {
        this.selectedPerfiles = [];
        this.getPerfiles(true);
      }
    });
  }
  public editPerfil(perfil: Perfil): void {
    this.bsModalRef = this.bsModalService.show(FormularioPerfilesComponent, {
      initialState: { perfil: perfil, title: "Edición de Perfil" },
    });
    this.bsModalRef.content.onClose.subscribe((perfilModificado) => {
      if (perfilModificado === true) {
        this.selectedPerfiles = [];
        this.getPerfiles(true);
      }
    });
  }

  public confirmDeletePerfil(): void {
    this.modalService
      .showConfirm({
        title: ModalTitles.warning,
        body: mensajes.formularioPerfiles.confirmEliminarPerfil.body,
        type: ModalType.warning,
      })
      .subscribe((confirm) => {
        if (confirm) this.deletePerfil();
      });
  }
  private deletePerfil() {
    const perfileDeletions = [];
    this.selectedPerfiles.forEach((selectedPerfil) => {
      perfileDeletions.push(this.perfilRepository.deletePerfil(selectedPerfil));
    });
    forkJoin(perfileDeletions)
      .pipe()
      .subscribe(() => {
        this.selectedPerfiles = [];
        this.getPerfiles(true);
      });
  }

  public getPerfiles(overwrite = false): void {
    this.subscriptions.push(
      this.perfilRepository.getPerfiles(overwrite).subscribe((perfiles) => {
        this.perfiles = perfiles.map(this.mapPerfil);
        this.perfiles.forEach((perfil) => {
          perfil.rolesCount = perfil.perfilRole.length;
        });

        this.observablePerfiles.next(this.perfiles);
      })
    );
  }
  public getRoles(overwrite = false): void {
    this.subscriptions.push(this.rolesRepository.getRoles(overwrite).subscribe());
  }

  private mapPerfil(perfil: Perfil): Perfil {
    return {
      ...perfil,
      roles: perfil.perfilRole.map((rol) => rol?.role?.nombre).join(", ") as any,
    };
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (!subscription.closed) subscription.unsubscribe();
    });
  }
}
